<template>
  <div>
    <title-bar :title-stack="['Device Groupe', this.$route.params.id]" />
    <section class="section is-main-section">
      <div class="columns">
        <div class="column is-4">
            <div class="box"> <!-- style="width: inherit; position: fixed;" -->
              <Map v-bind:timeCursor="timeCursor" device="c44f332230e9" :timeRange="timeRange"></Map>
              <plot v-bind:timeCursor="timeCursor" v-on:update:timeCursor="updateCursor" v-bind:timeRange="timeRange" v-on:update:timeRange="updateRange" title='Speed' yLabel='Velocity [km/h]' :traces="['c44f332230e9/speed']" :traceNames="['Speed']"></plot>
              <plot v-bind:timeCursor="timeCursor" v-on:update:timeCursor="updateCursor" v-bind:timeRange="timeRange" v-on:update:timeRange="updateRange" title='DOP' yLabel='Dilution of Precision [1]' :traces="['c44f332230e9/dop']" :traceNames="['Dilution of Precision']"></plot>
            </div>
        </div>
        <div class="column is-8">
          <div class="box">
            <plot v-bind:timeCursor="timeCursor" v-on:update:timeCursor="updateCursor" v-bind:timeRange="timeRange" v-on:update:timeRange="updateRange" title='Variance' yLabel='Variance/Energy over 5s [m^2/s^4]' :traces="['c44f332230e9/power3d', '4c11ae610960/power3d', '4c11ae61094c/power3d', '7c87ceff089c/power3d']" :traceNames="['Wagenkasten', 'Drehgestell', 'Radsatzlager rechts', 'Radsatzlager links']"></plot>
            <plot v-bind:timeCursor="timeCursor" v-on:update:timeCursor="updateCursor" v-bind:timeRange="timeRange" v-on:update:timeRange="updateRange" title='Acceleration Vertical Direction' yLabel='Acceleration [m/s^2]' :traces="['c44f332230e9/adxl357_z', '4c11ae610960/adxl357_y', '4c11ae61094c/adxl357_x', '7c87ceff089c/adxl357_x']" :traceNames="['Wagenkasten', 'Drehgestell', 'Radsatzlager rechts', 'Radsatzlager links']"></plot>
            <plot v-bind:timeCursor="timeCursor" v-on:update:timeCursor="updateCursor" v-bind:timeRange="timeRange" v-on:update:timeRange="updateRange" title='Acceleration Lateral Direction' yLabel='Acceleration [m/s^2]' :traces="['c44f332230e9/adxl357_y', '4c11ae610960/adxl357_z', '4c11ae61094c/adxl357_z', '7c87ceff089c/adxl357_z']" :traceNames="['Wagenkasten', 'Drehgestell', 'Radsatzlager rechts', 'Radsatzlager links']"></plot>
            <plot v-bind:timeCursor="timeCursor" v-on:update:timeCursor="updateCursor" v-bind:timeRange="timeRange" v-on:update:timeRange="updateRange" title='Acceleration Longitudional Direction' yLabel='Acceleration [m/s^2]' :traces="['c44f332230e9/adxl357_x', '4c11ae610960/adxl357_x', '4c11ae61094c/adxl357_y', '7c87ceff089c/adxl357_y']" :traceNames="['Wagenkasten', 'Drehgestell', 'Radsatzlager rechts', 'Radsatzlager links']"></plot>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import Plot from '@/components/TN-Plot'
import Map from '@/components/TN-Map'
import TitleBar from '@/components/TitleBar'

function yesterday () {
  var d = new Date()
  d.setDate(d.getDate() - 1)
  return d
}

export default {
  name: 'drehgestell',
  components: {
    Plot,
    TitleBar,
    Map
  },
  data () {
    return {
      id: null,
      timeRange: [yesterday(), new Date()],
      timeCursor: 0
    }
  },
  methods: {
    updateRange: function (val) {
      // console.log('updated range from event', val)
      this.timeRange = val
    },
    updateCursor: function (val) {
      this.timeCursor = val
    }
  }
}

</script>
